// extracted by mini-css-extract-plugin
export default {"root":"styles_root__zx5zp","woList":"styles_woList__cEJTe"};